const ENV_VARS = {
	ENVIRONMENT:   	'production',
	BRAND_ID:      	'initialstate',
	BRAND_NAME:	   	'Initial State',
	TRIAL_DAYS: 	14,
	THEME_URL:     	'https://theme.initialstate.com/prod/',
	ACCOUNT_URL:   	'https://account.initialstate.com',
	AUTH_URL:      	'https://auth.initialstate.com/#/',
	SUPPORT_EMAIL:  'support@initialstate.com',
	IOT_APP_URL: 	'https://iot.app.initialstate.com/cb/auth',
	IOT_PLANS_URL: 	'https://www.initialstate.com/#pricing',
	AUTH_API:      	'https://api.init.st/auth/',
	ACCOUNT_API:   	'https://api.init.st/account/',
	GTM_KEY: 		'GTM-TRX7CK6',
	STRIPE_TOKEN: 	'pk_live_zUGLO5FCm2k6M5Nm0WOaHgIr',
	SENTRY_DNS:		'https://16d83731d49c41bcb87e233ff1128b71@o966792.ingest.sentry.io/5981621'
};

function override(map) {
	for (var key in map) {
		if (map.hasOwnProperty(key) && (typeof map[key] === 'string' || typeof map[key] === 'number')) {
			ENV_VARS[key] = map[key];
		}
	}
}

// TODO: add update event
export {
	ENV_VARS as default,
	override
};



// WEBPACK FOOTER //
// ./src/modules/env-vars.js